import React from 'react';
import useStyle from './tableDataHeader.style';

export interface TableDataHeaderProps {
  labels: Array<string>;
}

export const TableDataHeader = ({ labels }: TableDataHeaderProps) => {
  const classes = useStyle();
  return (
    <thead className={classes.root}>
      <tr>
        {labels?.map(label => (
          <td key={label}>{label}</td>
        ))}
      </tr>
    </thead>
  );
};
